<template>
  <span class="m-badge m-badge-status">
    <span v-if="avatarUrl" class="m-avatar m-avatar-span" :style="avatarStyle">
      <img :src="avatarUrl" alt="">
    </span>
    <span v-else class="m-avatar m-avatar-icon" :style="avatarStyle">
      <span class="m-avatar-string">{{ name[0] }}</span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'AccountAvatar',
  components: {
  },
  props: {
    account: {
      type: Object,
      default: () => {
        return {
          im_icon: '',
          im_name: '',
          name: ''
        }
      }
    },
    width: {
      type: String,
      default: '36px'
    },
    height: {
      type: String,
      default: '36px'
    },
    fontSize: {
      type: String,
      default: '18px'
    }
  },
  data () {
    return {
    }
  },
  computed: {
    avatarUrl () {
      return this.account.id ? this.account.im_icon : this.account.avatar
    },
    name () {
      if (this.account.id) {
        return this.account.im_name ? this.account.im_name : this.account.nick
      } else if (this.account.teamId) {
        return this.account.name ? this.account.name : ''
      }
      return ''
    },
    avatarStyle () {
      return {
        width: this.width,
        height: this.height,
        lineHeight: this.height,
        fontSize: this.fontSize
      }
    },
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
.m-badge {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnim";
  position: relative;
  display: inline-block;
}
.m-badge-status {
  line-height: inherit;
  vertical-align: baseline;
}
.m-avatar {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 18px;
  vertical-align: middle;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  overflow: hidden;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  border-radius: 8px;
}
.m-avatar>img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.m-avatar-span {
  font-size: 18px;
  vertical-align: middle;
}
.m-avatar-icon {
  font-size: 18px;
  vertical-align: middle;
  background-color: #be65d9;
}
.m-avatar-string {
  transform: scale(0.777778) translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/common/im/AccountAvatar.vue